class Zaius {
    constructor() {
        if (
            typeof Settings.services['zaius'] !== 'undefined' &&
            Settings.services['zaius']['enabled'] === true
        ) {
            this.zaius = window['zaius'] || (window['zaius'] = []);
            this.isEnabled = true;
        } else {
            this.zaius = [];
            this.isEnabled = false;
        }
    }

    subscribe(email, listId, args = {}) {
        const payload = Object.assign(
            {
                email: email.toLowerCase(),
                list_id: [listId ? listId : this.getNewsletterListId()],
            },
            args
        );

        return new Promise(async (resolve, reject) => {
            if (!this.isEnabled) {
                return resolve('Zaius is not enabled.');
            }

            // try {
            try {
                await this.zaius.subscribe(payload);
                resolve();
            } catch (e) {
                console.log('Failed sending to Zaius.');
                reject(e);
            }

            // } catch (error) {
            //     reject(error)
            // }
        });
    }

    identity(email) {
        return new Promise(async (resolve, reject) => {
            if (!this.isEnabled) {
                return resolve('Zaius is not enabled.');
            }

            try {
                try {
                    await this.zaius.entity('customer', { email: email });
                    resolve();
                } catch (e) {
                    console.log('Failed sending to Zaius.');
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    event(name, options) {
        return new Promise(async (resolve, reject) => {
            if (!this.isEnabled) {
                return resolve('Zaius is not enabled.');
            }

            try {
                try {
                    await this.zaius.event(name, options);
                    resolve();
                } catch (e) {
                    console.log('Failed sending to Zaius.');
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    getNewsletterListId() {
        return !this.isEnabled ||
            typeof Settings.services['zaius']['newsletter_list_id'] == 'undefined'
            ? 'newsletter'
            : Settings.services['zaius']['newsletter_list_id'];
    }

    addToCart(productId) {
        return this.event('product', {
            action: 'add_to_cart',
            product_id: productId,
        });
    }

    removeFromCart(productId) {
        return this.event('product', {
            action: 'remove_from_cart',
            product_id: productId,
        });
    }

    async getVuid() {
        if (!this.isEnabled) {
            return null;
        }

        return new Promise(async (resolve, reject) => {
            // Tries to 2000 ms (2 seconds) before showing fallback.
            let tries = 20;

            while (tries > 0) {
                const found = await this.checkIfZaiusHasLoaded();

                if (found) {
                    return resolve(this.zaius.VUID);
                }

                tries--;
            }

            return reject(null);
        });
    }

    checkIfZaiusHasLoaded() {
        return new Promise(resolve => {
            setTimeout(() => {
                return resolve(typeof this.zaius.VUID !== 'undefined');
            }, 100);
        });
    }
}

export default new Zaius();
